<template>
  <v-container
    class="cmp-licencing-licencing_accounts-sidewindow dt-sidewindow"
  >
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedLicenceAccountDetails &&
                selectedLicenceAccountDetails.licence_account &&
                selectedLicenceAccountDetails.licence_account
                  .licence_account_name
            "
          >
            <span
              v-if="
                selectedLicenceAccountDetails &&
                  selectedLicenceAccountDetails.licence_account
              "
              >{{
                selectedLicenceAccountDetails.licence_account
                  .licence_account_name || "Account Name"
              }}
            </span>
          </div>
        </div>
      </div>
      <glayout
        :tabs="licenceAccountSidewindowTab"
        :options="[
          {
            text: $t('new_statement'),
            value: 'newStatment'
          },
          {
            text: $t('remainder_email'),
            value: 'remainderEmail'
          }
        ]"
        :loading="
          selectedLicenceAccountDetails && selectedLicenceAccountDetails.loading
        "
        @optionClicked="onTabOptionClicked"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :title="`${$t('account')} ${$t('tab_title_main_setup')}`"
                h="132"
              >
                <AccountSetup
                  :selectedLicenceAccountDetails="selectedLicenceAccountDetails"
                  @changed="onUpdated"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedLicenceAccountDetails &&
                      selectedLicenceAccountDetails.contact_relations &&
                      selectedLicenceAccountDetails.contact_relations.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('related_contacts')"
              >
                <RealtedContacts
                  :contact_relations="
                    selectedLicenceAccountDetails.contact_relations
                  "
                  :external_id="
                    `${
                      selectedLicenceAccountDetails.licence_account
                        .licence_account_id
                    }`
                  "
                  :external_table="'licence_account'"
                  @delete="onRelatedContactDelete"
                  @changed="onRelatedContactChange"
                  @contact_selected="onRelatedContactSelected"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('invoice_contact')">
                <InvoiceContact
                  :invoiceContact="
                    selectedLicenceAccountDetails.invoice_contact
                  "
                  :contactConfig="{
                    external_id:
                      selectedLicenceAccountDetails.licence_account
                        .licence_account_id,
                    external_table: 'l_licence_accounts',
                    external_name: 'contact_id',
                    config_type: 'LicenceAccountInvoiceConfig',
                    key: 'licence_account_id'
                  }"
                />
              </gbox>
              <gbox
                v-if="selectedLicenceAccountDetails"
                :title="$t('notes')"
                bc="var(--bc-note)"
              >
                <DBoxTextarea
                  :value="selectedLicenceAccountDetails.licence_account.notes"
                  :id="'notes'"
                  @blur="
                    e =>
                      onUpdated({
                        name: 'notes',
                        value: e.target.value
                      })
                  "
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="licences">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedLicenceAccountDetails &&
                      selectedLicenceAccountDetails.licences &&
                      selectedLicenceAccountDetails.licences.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: relatedLicenceHeight,
                    max: 10,
                    min:1
                  })
                "
                :title="$t('licence_string')"
              >
    
                <!-- {{ relatedLicenceHeight }} -->
                <RelatedLicence
                  :selectedLicenceAccountDetails="selectedLicenceAccountDetails"
                  :licence_account_id="parseInt(licence_account_id)"
                  @scroll="onScrollLicence"
                  @update="onUpdateRelatedLicence"
                  @delete="deleteRelatedLicence"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="licence_invoice">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedLicenceAccountDetails &&
                      selectedLicenceAccountDetails.licence_lines &&
                      selectedLicenceAccountDetails.licence_lines.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('not_yet_invoiced')"
              >
                <LicenceInvoiceList
                  :selectedLicenceAccountDetails="selectedLicenceAccountDetails"
                />
              </gbox>
              <gbox
              :h="
                  boxHeightNamed({
                    rowCount:
                      selectedLicenceAccountDetails &&
                      selectedLicenceAccountDetails.related_invoices &&
                      selectedLicenceAccountDetails.related_invoices.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :title="$t('invoice')"
              >
                <InvoiceList
                  :selectedLicenceAccountDetails="selectedLicenceAccountDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
  </v-container>
</template>

<script>
import { LicenceStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { licenceAccountsGetters } from "../../store/accounts/getters";
import { licenceAccountsActions } from "../../store/accounts/actions";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";

import { licenceAccountsListLDTRoutes } from "../../router/routes";
import { checkTabListPermission } from "../../../../router/guard";
import RealtedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import AccountSetup from "./account-setup";

import InvoiceContact from "@/dt-plugins/dbox-invoice-contact/dbox-invoice-contact.vue";
import LicenceInvoiceList from "./licence-list-invoice.vue";
import InvoiceList from "./invoice-list";
import RelatedLicence from "./related-licence-list.vue";
import { sendMailHref } from "../../../../utility";
import { onDetailsRowClicked } from "../../../../utility/route";
import { contactListLDTRoutes } from "../../../contacts/router/routes";
import { licenceAccountsService } from '../../services/licence-accounts.service';
export const moduleRoute = "licencing";
export const submenuRoute = "licence_accounts";

export default {
  components: {
    AccountSetup,
    InvoiceContact,
    RealtedContacts,
    DBoxTextarea,
    LicenceInvoiceList,
    InvoiceList,
    RelatedLicence
  },
  mounted:async function () {
    const licence_account_statuses =this?.licenceAccountsList?.licence_account_statuses||[]

    if(licence_account_statuses.length==0)
    {
      const advancedSearchData = await licenceAccountsService.licenceAccAdvancedSearchModalData();
  
      this.advancedSearchResponse = advancedSearchData?.data;

     

      this[ActionTypes.LicenceAccountsList.SET.ALL](this.advancedSearchResponse.licence_account_statuses);

    }

  },
  mixins: [createDTGridHost()],
  computed: {
    ...mapGetterObject(storeNS, licenceAccountsGetters),

    licenceAccountSidewindowTab: function() {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("tab_title_invoice_info")
        },
        {
          route: "licences",
          value: this.$t("tab_title_licences")
        },
        {
          route: "licence_invoice",
          value: `${this.$t("licence_invoice")}s`
        }
      ]);
    },

    licence_account_id: function() {
      return this.$route.params.licence_account_id;
    },

    relatedLicenceHeight:function(){
      const licences = this.selectedLicenceAccountDetails.licences;
      if(licences.length>0){
        
        
        console.log(licences,"HEIGHT")

        const bigAssetsCount = licences.reduce((accum,cur)=>{
          
          console.log(cur.assets.length,"HEIGHT 2")


          if(cur.assets.length>50){
            accum++;
          }
          return accum;
        },0);

        console.log(bigAssetsCount,"HEIGHT 2")

        if(bigAssetsCount>0){
          const bigAssetsCountHeight = parseInt(bigAssetsCount) * 70;

          const smallAssetCount = licences.length - bigAssetsCount;
          
          let smallAssetCountHeight=0;
          if(smallAssetCount>0){
            smallAssetCountHeight = parseInt(smallAssetCount) * 42 ;
          }

          return (bigAssetsCountHeight+smallAssetCountHeight)/licences.length;
        }else{
          return 32;
        }

        
      }
      else{
        return 32;
      }  

    },

    selectedLicenceAccountDetails: function() {
      const licenceAccountsDetails =
        (this.licenceAccountsDetails || {})[this.licence_account_id] || {};
      console.log("this.licenceAccountsDetails:::",this.licenceAccountsList)
      const licence_account = licenceAccountsDetails.licence_account || {};
      const invoice_contact = licenceAccountsDetails.invoice_contact || {};

      const licences = licenceAccountsDetails.licences || [];

      const licence_account_statuses =this?.licenceAccountsList?.licence_account_statuses||[]

      return {
        ...licenceAccountsDetails,
        licence_account,
        invoice_contact,
        licence_account_statuses,
        licences
      };
    }
  },
  methods: {
    ...mapActionObject(storeNS, licenceAccountsActions),

    async onTabOptionClicked(value) {
      switch (value) {
        case "newStatment": {
          this.$router.push({
            ...this.$route,
            query: {
              modal: "new_statement_modal",
              licence_account_id: this.licence_account_id
            }
          });
          break;
        }
        case "remainderEmail": {
          const res =  await  licenceAccountsService.reminderEmail(this.licence_account_id);
          
          console.log(res.data.to);
          sendMailHref({
            subject: res.data.subject,
            body: res.data.msg,
            mails: [ res.data.to ]
          });
          break;
        }
      }
    },

    onUpdated: function(payload) {
      this[ActionTypes.LicenceAccountsDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedLicenceAccountDetails
      });
    },

    onRelatedContactDelete: function(contact) {
      this[ActionTypes.LicenceAccountRelatedContacts.DELETE.SINGLE]({
        contact,
        licence_account: this.selectedLicenceAccountDetails.licence_account
      });
    },
    onRelatedContactChange: function({ name, value, item }) {
      this[ActionTypes.LicenceAccountRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
        licence_account: this.selectedLicenceAccountDetails.licence_account
      });
    },

    onRelatedContactSelected: function(contact) {
      onDetailsRowClicked(this.$router, contact, contactListLDTRoutes);
    },

    deleteRelatedLicence: function(payload) {
      this[ActionTypes.AccountRelatedLicence.DELETE.SINGLE](payload);
    },

    onUpdateRelatedLicence:function(payload){
      console.log(payload)
       this[ActionTypes.AccountRelatedLicence.UPDATE.SINGLE](payload);
    },
    onScrollLicence:function(payload){
      this[ActionTypes.AccountRelatedLicence.INSERT.MULTIPLE](payload);
    }
  }
};
</script>

<style lang="scss">
.cmp-licencing-licencing_accounts-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 119px);
  }
}
</style>
